<template>
  <div class="subdivision__main-block">
    <p class="subtitle">
      {{ subtitle[0] }}
      <span>{{ subtitle[1] }}</span>
      {{ subtitle[2] }}
    </p>
    <div class="content">
      <div class="title" ref="block1">
        <p>{{ movingBlockText }}</p>
        <custom-button-join />
      </div>
      <div class="logos-block">
        <subdivision-choose-item :subdivisions="subdivisions" />
      </div>
    </div>
  </div>
</template>

<script>
import SubdivisionChooseItem from "@/components/main/subDivisionChoose/methods/SubDivisionChooseItem.vue";
import CustomButtonJoin from "@/components/UI/CustomButtonJoin.vue";

export default {
  name: "subdivision-choose-content",
  components: {
    CustomButtonJoin,
    SubdivisionChooseItem,
  },
  props: {
    subtitle: {
      type: Array,
      default: () => [],
    },
    movingBlockText: {
      type: String,
      default: () => "",
    },
    subdivisions: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.handleScroll(); // Вызываем при монтировании для начальной позиции
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (this.$route.path !== "/" || window.innerWidth < 1350) {
        return;
      }

      const block1 = this.$refs.block1;
      const container = block1.parentElement;
      const block2Height = 1810;
      const block1Height = 300;

      const containerRect = container.getBoundingClientRect();
      const containerTop = containerRect.top;
      const containerBottom = containerRect.bottom;

      if (containerTop < 0 && containerBottom > block1Height) {
        const scrollOffset = Math.abs(containerTop);
        const maxOffset = block2Height - block1Height;

        const translateY = Math.min(scrollOffset, maxOffset);
        block1.style.transform = `translateY(${translateY}px)`;
      } else if (containerTop >= 0) {
        block1.style.transform = "translateY(0)";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.subdivision__main-block {
  position: relative;
}
.content {
  display: flex;
  gap: 22px;

  @media (max-width: 1360px) {
    flex-direction: column;
  }

  .title {
    width: 438px;
    display: flex;
    flex-direction: column;
    gap: 65px;
    transition: transform 0s;
    height: max-content;
    @media (max-width: 767px) {
      gap: 35px;
    }
    @media (max-width: 1360px) {
      width: 100%;
    }

    p {
      font-family: "UAF Sans H", serif;
      font-weight: 700;
      font-size: 44px;
      line-height: 60px;
      text-transform: uppercase;

      @media (max-width: 767px) {
        font-size: 32px;
        line-height: 38px;
      }
    }
  }

  .logos-block {
    display: flex;
    flex-direction: column;
    gap: 22px;
  }
}

.subdivision {
  &__main-block {
    display: flex;
    flex-direction: column;
    gap: 44px;

    .subtitle {
      max-width: 1000px;
      font-family: UAF Sans;
      font-weight: 400;
      font-size: 24px;
      line-height: 34px;
      letter-spacing: 0%;

      @media (max-width: 767px) {
        font-size: 18px;
        line-height: 22px;
      }
    }
  }
}

.logos-block {
  padding: 20px;

  @media (max-width: 767px) {
    padding: 0;
  }
}

.subtitle span {
  font-family: "UAF Sans H", serif;
  text-transform: uppercase;
}
</style>
